import React, { useRef, useState, useEffect } from 'react';
import { ShoppingCart, MessageCircle } from 'lucide-react';

function FadeIn({ children, className = '' }) {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const observer = new IntersectionObserver(([e]) => { if (e.isIntersecting) setVisible(true); }, { threshold: 0.05 });
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);
  return (
    <div ref={ref} className={`transition-all duration-700 ${className}`}
      style={{ opacity: visible ? 1 : 0, transform: visible ? 'translateY(0)' : 'translateY(30px)' }}>
      {children}
    </div>
  );
}

export default function BuyEpisodes() {
  return (
    <section id="buy" data-testid="buy-episodes-section" className="py-20 sm:py-28 relative">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <FadeIn className="max-w-2xl mx-auto text-center">
          <div className="glass-card rounded-2xl p-10 sm:p-14 relative overflow-hidden">
            <div className="absolute top-0 left-0 w-20 h-20 bg-gradient-to-br from-neonGold/10 to-transparent" />
            <div className="absolute bottom-0 right-0 w-20 h-20 bg-gradient-to-tl from-neonBlue/10 to-transparent" />

            <div className="w-16 h-16 mx-auto mb-6 rounded-full bg-neonGold/10 border border-neonGold/30 flex items-center justify-center">
              <ShoppingCart className="w-8 h-8 text-neonGold" />
            </div>

            <h2 className="font-heading text-3xl sm:text-4xl font-bold text-white mb-4">
              Buy Full Audio Episodes
            </h2>

            <p className="font-hindi text-neonGold/80 text-lg mb-2">
              पूरे एपिसोड पढ़ने के लिए Telegram पर DM करें
            </p>
            <p className="text-gray-400 mb-8">
              To buy full audio episodes, send a message on Telegram. Quick response, easy payment, instant access.
            </p>

            <a
              href="https://t.me/Ak0nikk"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="buy-episodes-btn"
              className="inline-flex items-center gap-2 bg-gradient-to-r from-neonGold to-yellow-500 text-black font-bold px-10 py-4 rounded-full hover:shadow-[0_0_30px_rgba(255,215,0,0.4)] transition-all text-sm"
            >
              <MessageCircle size={18} />
              Buy Audio Episodes Now
            </a>

            <p className="text-xs text-gray-600 mt-4">
              Direct link to: t.me/Ak0nikk
            </p>
          </div>
        </FadeIn>
      </div>
    </section>
  );
}
